module.exports = __webpack_public_path__ + "static/media/Antigua.a16685f1.png";